document.addEventListener('quizKitResultsPageLoaded', () => {
  const hasProducts = () => {
    const $products = document.querySelector('[id^="quiz-kit-results-grid"]');

    return $products !== null
  }

  const getProducts = () => {
    const $products = document.querySelector('[id^="quiz-kit-results-grid"]');
    const $productList = $products.querySelectorAll('[id^="quiz-kit-results-product"]');

    return Array.from($productList);
  }
  window.setTimeout(() => {
    if (!hasProducts()) {
      return;
    }

    const products = getProducts();
    products.forEach((product) => {
      const $product = product;
      const $productLink = $product.querySelector('a');
      const productUrl = $productLink.getAttribute('href').split('?')[0].concat('?view=quiz');

      // fetching productUrl
      window.fetch(productUrl)
        .then(response => response.text())
        .then((data) => {
          window.console.log({data});
          const parser = new DOMParser();
          const htmlDocument = parser.parseFromString(data, "text/html");
          const $productDescription = htmlDocument.querySelector('.product-card__inspiration');

          if ($productDescription) {
            // Insert $productDescription after <h3>
            const $productTitle = $product.querySelector('h3');
            $productTitle.parentNode.appendChild($productDescription);

            // $product.appendChild();
          }
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    });
  }, 200);
}, false);